<template>
  <div id="product">   
    <AddProductsComponent></AddProductsComponent>     
  </div>
</template>

<script>

  import AddProductsComponent from '@/components/cust_components/Addproducts_component.vue';
  
  export default {
      name: 'AddProductsView',
      data() {
          return {
          }
      },
      components: {     
        AddProductsComponent,
      }
  }
</script>